import Sortable from 'sortablejs';
import './show-hide-note';

// List with handle
Sortable.create(listWithHandle, {
    handle: '.handle',
    animation: 150,
    
    onChange: function(event, ui) {
        console.log(this.el);
        updateFields(this.el)
    },

    onEnd: function (event, ui) {
        updateFields(this.el)
    },

});

function updateFields($list) {
    $('.input-task').each(function (idx) {
        var $input = $(this).find('input');
        var $textArea = $(this).find('textarea');
        var $deleteButton = $(this).find('.btn-delete-checklist-item')

        $input.each(function () {
            // Updates name of hidden input in edit page
            if( !this.id ){
                this.name = `checklist-item-status[${idx}]`;
            }

            // Updates name, id, data-item attribute of field
            if(this.getAttribute("data-item") && this.id){
                this.name = `checklist-item[${idx}]`
                this.setAttribute("id", `checklist-item-${idx}`);
                this.setAttribute("data-item", idx);
            }
            
            // removes x-button on the first task field on the form
            if(this.getAttribute("data-item") && this.getAttribute("data-item") == 0){
                $(`#checklist-item-${idx}`).siblings('.btn-delete-checklist-item').remove();
            }

            // adds x-button to the field if it is removed from first position
            if(this.getAttribute("data-item") && this.getAttribute("data-item") != 0 && $deleteButton.length == 0){
                $(`#checklist-item-${idx}`).after(
                    '<button class="btn btn-link text-decoration-none btn-delete-checklist-item" type="button" title="Remove Task"></button>'
                )
            }
        });

        // Updates name and id of the checklist item notes field
        $textArea.each(function(){
            this.name = `checklist-item-note[${idx}]`;
            this.setAttribute("id", `checklist-item-note-${idx}`)
        })
    })
}

$(document).ready(function(){
    var list = document.getElementById('listWithHandle');
    updateFields(list);
})

$(document).on('click', '.btn-add-checklist-item', function() {
    var list = document.getElementById('listWithHandle');
    var last_child = $('.checklist-container .input-group:last-child .form-control').attr('data-item');

    // Adds field after the the field that contains the clicked + button
    $(this).closest('.input-task').after(
        '<div class="input-task">' +
            '<div class="input-group">' +
                '<div class="handle"></div>' +
                '<input required type="text" name="checklist-item[' + (Number(last_child) + 1) + `]" id="checklist-item-` + (Number(last_child) + 1) + '" data-item="' + (Number(last_child) + 1) + '" class="form-control" placeholder="Enter a task" maxlength="50">' +
                '<button class="btn btn-link text-decoration-none btn-delete-checklist-item" type="button" title="Remove Task"></button>' +
                '<button class="btn btn-link text-decoration-none btn-add-checklist-item" type="button" title="Add Task"></button>' +
            '</div>' +
            '<div class="input-note form-group">' +
                '<textarea name="checklist-item-note['+ (Number(last_child) + 1) +']" id="checklist-item-note-'+(Number(last_child) + 1)+'" class="form-control" placeholder="Add a note"></textarea>' +
                '<button type="button" class="btn btn-toggle-input btn-toggle-note p-0">' +
                  '<span class="text">' +
                    '<span class="text-hide">Hide</span>' +
                    '<span class="text-show">Show</span>' +
                    ' Notes' +
                  '</span>' +
                  '<span class="icon"></span>' +
                '</button>' +
            '</div>' +
        '</div>'
    )

    updateFields(list);
})

$(document).on('click', '.btn-delete-checklist-item', function() {
    var list = document.getElementById('listWithHandle');

    $(this).closest('.input-task').remove();

    updateFields(list);
})